<template>
  <div class="columns is-vcentered">
    <div class="full-width border-top-1">
      <div class="card-header-title pd-0 hoverCardHeader pdl-100px stripped-face
        columns is-marginless is-justify-content-space-between">
        <div class="column is-narrow ellipsis">
          <div class="columns is-vcentered">
            <div class="column is-4 is-cursor-pointer">
              <b-icon icon="subdirectory-arrow-right" class="mgt-5px">
              </b-icon>
            </div>
            <div class="column is-4">
              <qd-checkbox :value="face.selected" @input="faceSelectedEvent" v-if="afficherCheckbox"
              ></qd-checkbox>
            </div>
          </div>
        </div>
        <div class="column is-2 ellipsis mgl-20px">
          <div class="columns">
            <div class="column is-narrow pdr-0">
              {{ $t('emplacementDispositifMaterielFacePicker.tab.face') }}
            </div>
            <div class="column is-7">
              <router-link-blank class="ellipsis"
                :to="{ name: 'c.gabed.emplacement-face', params: { idFace: face.id,
            id: emplacementId }}"
                :message="face.code"/>
            </div>
          </div>
        </div>
        <div class="column has-text-default is-3 ellipsis">
          {{ $t(getEtatFace(face.etat)) }}
        </div>
        <div class="column has-text-default is-4">
          <div v-if="loaderFace && afficherAffectation">
            {{ $t('general.chargement') }}
          </div>
          <div v-else-if="(affectations && affectations.length > 0
              || face.faceMotifNonComId) && afficherAffectation">
            <info-affectations
                :affectations="affectations"
                :row="face"
                :faceMotifNonComId="face.faceMotifNonComId"
                :periode="periode"
                :facesList="facesList"
                :isFromLigneFace="true">
            </info-affectations>
          </div>
          <div v-else-if="afficherAffectation">
            {{ $t('emplacementDispositifMaterielFacePicker.ligneFaces.noAffectation') }}
          </div>
        </div>
        <div class="column is-1 has-text-right">
          <b-tag type="has-background-subMenu" class="has-text-white" v-if="!face.actif">
            {{$t('emplacementDispositifMaterielFacePicker.archive')}}
          </b-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import infoAffectations from '@/components/general/infoAffectations';

export default {
  name: 'ligneFace',
  components: {
    routerLinkBlank,
    infoAffectations,
  },
  props: {
    face: {
      required: false,
      default: null,
      type: Object,
    },
    emplacementId: {
      required: true,
      default: null,
      type: String,
    },
    loaderFace: {
      required: true,
      type: Boolean,
    },
    afficherCheckbox: {
      required: false,
      default: true,
      type: Boolean,
    },
    affectations: {
      required: false,
      default: null,
      type: Array,
    },
    selectOnlyOneObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    periode: {
      type: Object,
      default: null,
      required: true,
    },
    facesList: {
      type: Array,
      default: null,
    },
    afficherAffectation: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getEtatFace(etat) {
      return ETAT_DISPOSITIF_PUBLICITAIRE.find((el) => {
        return el.value === etat;
      }).libelle;
    },
    faceSelectedEvent(newStatus) {
      if (this.selectOnlyOneObject) this.$emit('passToFalse', this.face.id);
      this.face.selected = newStatus;
      this.$emit('faceSelected');
    },
  },
};
</script>
